import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {AuthService} from "../../../../shared/services/auth.service";
import {first} from "rxjs/operators";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";
import {ReceivablesPaymentImportRowService} from "../../../../shared/services/receivables-payment-import-row.service";

@Component({
  selector: 'app-receivables-payment-import-row-add',
  templateUrl: './receivables-payment-import-row-add.component.html',
  styleUrls: ['./receivables-payment-import-row-add.component.scss']
})
export class ReceivablesPaymentImportRowAddComponent implements OnInit, OnDestroy {

  userPermissions: ReplaySubject<UserPermissions>;

  userPermissionss: UserPermissions;
  receivablesPaymentImportRowForm: FormGroup;
  formErrors: any = {};
  noteControl: FormControl;
  transferAmountControl: FormControl;
  transferTitleControl: FormControl;
  receivablesBalanceControl: FormControl;
  processingRequest = false;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private receivablesPaymentImportRowService:  ReceivablesPaymentImportRowService,
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private auth: AuthService,
  ) {
    this.userPermissions = this.auth.getUserPermissions();
    this.receivablesPaymentImportRowForm = this.fb.group({
      receivablesBalance: this.receivablesBalanceControl = fb.control('', [Validators.required]),
      transferTitle: this.transferTitleControl = fb.control('', [Validators.required]),
      transferAmount: this.transferAmountControl = this.fb.control('', [Validators.required]),
      note: this.noteControl = fb.control(''),
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  save(): void {
    if (!this.receivablesPaymentImportRowForm.valid) {
      this.receivablesPaymentImportRowForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    this.receivablesPaymentImportRowService.sendForm(this.receivablesPaymentImportRowForm.getRawValue()
    )
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snackBar.open('Pomyślnie utworzono wpłatę', '', {
          duration: 2000,
        });
        this.processingRequest = false;
          this.router.navigate(['/naleznosci/wplaty/szczegoly', response.uuid]);
      }, (error: HttpErrorResponse) => {

        this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.receivablesPaymentImportRowForm, this.formErrors);
        }
      });
  }

  cancel(): void {
    this.router.navigate(['/naleznosci/wplaty/rozliczone']);
  }
}
